/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ business: NonNullable<unknown> }} Booking_Portal_Prepay_TransferInputs */

const en_booking_portal_prepay_transfer = /** @type {(inputs: Booking_Portal_Prepay_TransferInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transfer to ${i?.business}:`)
};

const pl_booking_portal_prepay_transfer = /** @type {(inputs: Booking_Portal_Prepay_TransferInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przelew na konto ${i?.business}:`)
};

/**
* | output |
* | --- |
* | "Transfer to {business}:" |
*
* @param {Booking_Portal_Prepay_TransferInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_prepay_transfer = /** @type {((inputs: Booking_Portal_Prepay_TransferInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Prepay_TransferInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_prepay_transfer(inputs)
	return en_booking_portal_prepay_transfer(inputs)
});